export default {
  hello: '안녕하세요',
};
